<template>
    <div class="container">
        <a-spin tip="Carregando..." :spinning="spinning">
            <a-config-provider :locale="currentLocale">
                <a-card>
                    <template #title>
                        <a-breadcrumb separator=">">
                            <a-breadcrumb-item>
                                <span>Siglas</span>
                            </a-breadcrumb-item>
                            <a-breadcrumb-item>Listar</a-breadcrumb-item>
                        </a-breadcrumb>
                    </template>
                    <template #extra>
                        <a-button :icon="h(PlusOutlined)" @click="newRegister">Novo Registro</a-button>
                    </template>
                    <br><br>

                    <a-table :columns="columns" :data-source="dataSource" bordered>
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.dataIndex === 'zoneamento'">
                                {{ record.description }}
                            </template>
                            <template v-if="column.key === 'acao'">
                                <a-tooltip title="Ver HTML">
                                    <a-button type="primary" class="center-flex" shape="circle"
                                              style="background-color: #2f7d2f" @click="previewHtml(record.html)">
                                        <template #icon>
                                            <EyeOutlined/>
                                        </template>
                                    </a-button>
                                </a-tooltip>
                                <a-tooltip title="Alterar">
                                    <a-button type="primary" class="center-flex" shape="circle"
                                              @click="update(record)">
                                        <template #icon>
                                            <FormOutlined/>
                                        </template>
                                    </a-button>
                                </a-tooltip>
                                <a-tooltip title="Excluir">
                                    <a-button type="primary"
                                               class="center-flex"
                                              danger
                                              shape="circle"
                                              @click="destroy(record)"
                                    >
                                        <template #icon>
                                            <DeleteOutlined/>
                                        </template>
                                    </a-button>
                                </a-tooltip>
                            </template>
                        </template>
                    </a-table>
                </a-card>
            </a-config-provider>
        </a-spin>
        <a-modal v-model:open="isModalVisible" title="Preview HTML" footer=" " @ok="handleOk">
            <div v-html="htmlPreview">
            </div>
        </a-modal>
    </div>
</template>
<script setup>
import {ref, h, onMounted} from 'vue';
import {PlusOutlined, FormOutlined, DeleteOutlined, EyeOutlined} from '@ant-design/icons-vue';
import ptBR from 'ant-design-vue/es/locale/pt_BR';
import {notification} from 'ant-design-vue';
import { openNotification } from '../../../../utils/utilities';

const dataSource = ref();
const currentLocale = ref(ptBR);
const spinning = ref(false);

const route = '/api/viabilidade/siglas';
const isModalVisible = ref(false)

const htmlPreview = ref();

const handleOk = () => {
    isModalVisible.value = false;
};
const previewHtml = (html) => {
    htmlPreview.value = html
    isModalVisible.value = true
}

const columns = ref(
    [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: {
                compare: (a, b) => a.id - b.id,
            },
            width: 150,
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            sorter: {
                compare: (a, b) => a.name - b.name,
            },
        },
        {
            title: 'Descrição',
            dataIndex: 'description',
            key: 'name',
            width: 150,
            sorter: {
                compare: (a, b) => a.name - b.name,
            },
        },
        {
            title: 'Ação',
            key: 'acao',
            width: 50,
        }
    ]
);

const update = (data) => {
    window.location.href = `siglas/${data.id}/edit`;
}

const newRegister = () => {
    window.location.href = "siglas/create"
}


onMounted(async () => {
    await load();
});

const load = async () => {
    try {
        spinning.value = true
        const response = await window.axios.get(route);
        dataSource.value = response.data.data;
        spinning.value = false;
    } catch (error) {
        spinning.value = false;
    }
}


const destroy = async (data) => {
    try {
        const response = await window.axios.delete(route + `/${data.id}`);
        openNotification('success', response.data.message)
        load();
    } catch (error) {
        openNotification('error', error.message)
    }
}
</script>

<style scoped>
.center-flex {
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.anticon {
    vertical-align: 2px !important;
}
</style>
